import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const SubStepDetail = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  cursor: "pointer",
}));

export const StepLinkDescription = styled("span")(() => ({
  color: colors.blue600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  textDecorationLine: "underline",
}));

export const StepDescription = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  textAlign: "left",
  color: colors.gray600,
}));
